import React from 'react';
import SponsorPart from './components/SponsorPart';
import './Sponsors.scss';

const organizersImgs = [
  {
    src: 'imgs/logos/accenture.png',
    alt: 'Accenture',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://careers.accenture.com/sk-sk/Pages/index.aspx'
  },
  {
    src: 'imgs/logos/STU-FEI-zfv.png',
    alt: 'STU FEI',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.fei.stuba.sk/'
  }
];

const platinumPartner = [
  {
    src: 'imgs/logos/GoogleCloud_FullColor.png',
    alt: 'Google Cloud',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    // classes: 'is-4-desktop is-full-mobile logo-margin',
    classes: 'is-full',
    url: 'https://cloud.google.com/'
  }
];

const partnersImgs = [
  {
    src: 'imgs/logos/VUB_LOGO.png',
    alt: 'VUB',
    imgWidthLarge: '320px',
    imgWidthDesktop: '320px',
    imgWidthTablet: '320px',
    imgWidthMobile: '320px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.vub.sk/'
  },
  {
    src: 'imgs/logos/siemens.png',
    alt: 'Siemens',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://new.siemens.com/sk/sk/spolocnost/kariera.html'
  },
  {
    src: 'imgs/logos/redhat.png',
    alt: 'Redhat',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.redhat.com/en/partners/accenture'
  },
  {
    src: 'imgs/logos/Couchbase.png',
    alt: 'Couchbase',
    imgWidthLarge: '270px',
    imgWidthDesktop: '270px',
    imgWidthTablet: '270px',
    imgWidthMobile: '270px',
    classes: 'is-6-desktop is-full-mobile',
    url: ' https://www.couchbase.com'
  },
  // {
  //   src: 'imgs/logos/GoogleCloud.png',
  //   alt: 'Google Cloud',
  //   imgWidthLarge: '270px',
  //   imgWidthDesktop: '270px',
  //   imgWidthTablet: '270px',
  //   imgWidthMobile: '270px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://cloud.google.com/'
  // },
  {
    src: 'imgs/logos/takeda_logo.png',
    alt: 'Takeda',
    imgWidthLarge: '280px',
    imgWidthDesktop: '280px',
    imgWidthTablet: '280px',
    imgWidthMobile: '280px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.takeda.com/sk-sk/who-we-are/icc/'
  },
  {
    src: 'imgs/logos/ErsteDigital.png',
    alt: 'ErsteDigital',
    imgWidthLarge: '230px',
    imgWidthDesktop: '230px',
    imgWidthTablet: '230px',
    imgWidthMobile: '230px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.erstedigital.com/en/career'
  }
  // {
  //   src: 'imgs/logos/jb_beam.png',
  //   alt: 'Jetbrains',
  //   imgWidthLarge: '120px',
  //   imgWidthDesktop: '120px',
  //   imgWidthTablet: '120px',
  //   imgWidthMobile: '120px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://www.jetbrains.com/'
  // }
];

const mediaPartnersImgs = [
  {
    src: 'imgs/logos/robimeit.png',
    alt: 'RobimeIT',
    imgWidthLarge: '200px',
    imgWidthDesktop: '200px',
    imgWidthTablet: '200px',
    imgWidthMobile: '200px',
    // classes: 'is-6-desktop is-full-mobile logo-margin',
    classes: 'is-full',
    url: 'https://robime.it/'
  }
  // {
  //   src: 'imgs/logos/touchit.png',
  //   alt: 'TouchIt',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://touchit.sk/'
  // },
  // {
  //   src: 'imgs/logos/NEXTECH.jpg',
  //   alt: 'Nextech',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://www.pcrevue.sk/pc-revue'
  // },
  // {
  //   src: 'imgs/logos/zive.jpg',
  //   alt: 'Zive',
  //   imgWidthLarge: '150px',
  //   imgWidthDesktop: '150px',
  //   imgWidthTablet: '150px',
  //   imgWidthMobile: '150px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://zive.aktuality.sk/'
  // }
];

const supportersImgs = [
  {
    src: 'imgs/logos/tuli.png',
    alt: 'Tuli',
    imgWidthLarge: '110px',
    imgWidthDesktop: '110px',
    imgWidthTablet: '110px',
    imgWidthMobile: '110px',
    styles: 'is-6-desktop is-full-mobile',
    url: 'https://tuli.sk/'
  },
  {
    src: 'imgs/logos/Photoneo_logo.png',
    alt: 'Photoneo',
    imgWidthLarge: '350px',
    imgWidthDesktop: '350px',
    imgWidthTablet: '350px',
    imgWidthMobile: '350px',
    classes: 'is-6-desktop is-full-mobile',
    url: ' https://www.photoneo.com/'
  }
];

const Sponsors = () => (
  <section className="section" id="sponsors">
    <SponsorPart imgs={organizersImgs} title="ORGANIZERS" />
    <SponsorPart imgs={platinumPartner} title="PLATINUM PARTNER" />
    <SponsorPart imgs={partnersImgs} title="PARTNERS" />
    <SponsorPart imgs={supportersImgs} title="SUPPORTERS" />
    <SponsorPart imgs={mediaPartnersImgs} title="MEDIA PARTNERS" />
  </section>
);

export default Sponsors;
